import { faXmarkCircle } from '@fortawesome/free-regular-svg-icons'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const SearchBar = ({ searchValue, setSearchValue, handleCustomSkillSelection }) => {

    const handleSubmit = (e) => {
        e.preventDefault()
        handleCustomSkillSelection()
    }

    return (
        <div className='relative'>
            <div className='absolute inset-y-0 left-0 pl-3 flex items-center'>
                <FontAwesomeIcon icon={faMagnifyingGlass} className={`text-lg ${searchValue ? 'text-white' : 'text-white/50'}`}/>
            </div>
            <form onSubmit={handleSubmit}>
                <input 
                    type='text'
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder='Search any topic you’re interested in'
                    className='w-full bg-[#406AFF]/10 text-white rounded-lg placeholder:text-sm md:placeholder:text-white/50 placeholder:font-medium placeholder:text-white/50 bg-transparent pl-10 border-2  border-[#70AEFF]/50 goal'
                />
            </form>
            {searchValue && <div className='absolute cursor-pointer inset-y-0 right-0 pr-3 flex items-center' onClick={() => setSearchValue('')}>
                <FontAwesomeIcon icon={faXmarkCircle} className='text-xl'/>
            </div>}
        </div>
    )
}

export default SearchBar